import { call, put } from 'redux-saga/effects';
import { alertPush, sendError } from '../../../';
import { emailVerificationData, emailVerificationError, EmailVerificationFetch } from '../actions';
import api from '../../../../api-new/http';
import { appUrls } from '../../../../api-new/urls';

export function* emailVerificationSaga(action: EmailVerificationFetch) {
    try {
        yield call(() => api.post(`${appUrls.authenURL}/verify-request`, action.payload));
        yield put(emailVerificationData());
        yield put(alertPush({message: ['📩 Verification Email Sent', 'Please check your inbox and follow the instructions to verify your email.'], type: 'success'}));
    } catch (error: any) {
            const errorSetup = {
                message: error.response.data.errors[0].errorMessage,
                code: error.response.status,
                codeConfig: error.response.data.errors[0].errorCode,
            };
            yield put(
                sendError({
                    error: errorSetup,
                    processingType: 'alert',
                    extraOptions: {
                        actionError: emailVerificationError,
                    },
                }),
            );
        }
}
